export default __webpack_public_path__ + "static/media/backArrow.23c8e2e8.svg";